import { Component, CUSTOM_ELEMENTS_SCHEMA, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { AnalyticsChartComponent } from './analytics-chart.component';
import { format } from 'date-fns';
import { Colors } from '../../colors';

@Component({
  selector: 'app-analytics-line-chart',
  template: `
    <mat-card-title>{{ formattedStatValue }}</mat-card-title>
    @if (!hasData) {
      <mat-card-subtitle class="no-data-message">
        {{ 'ANALYTICS.NO_DATA' | translate }}
      </mat-card-subtitle>
    }
    @if (hasData) {
      <!--    <chart [options]="graphOptions"></chart>-->
    }
    `,
  styles: [
    `
      .no-data-message {
        padding-top: 20px;
      }
    `,
  ],
  standalone: true,
  imports: [MatCardModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AnalyticsLineChartComponent extends AnalyticsChartComponent {
  getOptions(): void {
    super.getOptions();
    const statFormat = this.statFormat;
    const analyticsChartService = this.analyticsChartService;
    this.graphOptions.chart.type = 'line';
    this.graphOptions.chart.height = 100;
    this.graphOptions.xAxis = { visible: false };
    this.graphOptions.yAxis = { visible: false };
    this.graphOptions.tooltip = {
      formatter: function (): string {
        return (
          format(new Date(this.x), 'MMM do, yyyy') + ': ' + analyticsChartService.formatStatValue(this.y, statFormat)
        );
      },
    };
    this.graphOptions.plotOptions = {
      series: {
        marker: {
          enabled: false,
        },
      },
    };
    this.graphOptions.legend = {
      align: 'right',
      verticalAlign: 'top',
      layout: 'vertical',
      labelFormatter: function (): string {
        const label = this.name;
        const maxLength = 20;
        if (label.length > maxLength) {
          return label.substring(0, maxLength - 3) + '...';
        }
        return this.name;
      },
    };
    this.graphOptions.colors = Colors.purpleSequence;
    this.graphOptions.series = [];
    for (let n = 0; n < this.graphData.length; n += 1) {
      const data = this.graphData[n];
      let label = null;
      if (this.labels) {
        label = this.labels[n] || null;
      }
      this.graphOptions.series.push({
        data: data,
        name: label,
        type: 'line',
      });
    }
  }
}
